// Mock data for Portal México

export const weatherData = [
  {
    city: "Ciudad de México",
    temp: "22°C",
    condition: "Parcialmente nublado",
    high: "25°C",
    low: "15°C"
  },
  {
    city: "Guadalajara",
    temp: "28°C",
    condition: "Soleado",
    high: "32°C",
    low: "18°C"
  },
  {
    city: "Monterrey",
    temp: "30°C",
    condition: "Despejado",
    high: "34°C",
    low: "22°C"
  }
];

export const trendingTopics = [
  "Liga MX Apertura 2025",
  "Toluca campeón",
  "Doménica Montero estreno",
  "Navidad 2025 México",
  "Dólar tipo de cambio",
  "Clima CDMX diciembre",
  "Posadas 2025"
];

export const popularSites = [
  { name: "Google", url: "https://www.google.com.mx", icon: "search" },
  { name: "WhatsApp Web", url: "https://web.whatsapp.com", icon: "message-circle" },
  { name: "Facebook", url: "https://www.facebook.com", icon: "facebook" },
  { name: "X (Twitter)", url: "https://www.x.com", icon: "twitter" },
  { name: "Instagram", url: "https://www.instagram.com", icon: "instagram" },
  { name: "Netflix MX", url: "https://www.netflix.com/mx", icon: "tv" },
  { name: "Disney+", url: "https://www.disneyplus.com", icon: "film" },
  { name: "Mercado Libre", url: "https://www.mercadolibre.com.mx", icon: "shopping-cart" },
  { name: "BBVA", url: "https://www.bbva.mx", icon: "landmark" },
  { name: "YouTube", url: "https://www.youtube.com", icon: "youtube" },
  { name: "Amazon MX", url: "https://www.amazon.com.mx", icon: "package" },
  { name: "Spotify", url: "https://www.spotify.com", icon: "music" }
];

export const newsArticles = [
  {
    id: 1,
    title: "Toluca se corona campeón del Apertura 2025 con 37 puntos",
    source: "ESPN MX",
    time: "Hace 2 horas",
    category: "deportes",
    image: "https://images.unsplash.com/photo-1579952363873-27f3bade9f55?w=400",
    url: "https://www.espn.com.mx/futbol/mexico/"
  },
  {
    id: 2,
    title: "Doménica Montero arrasa en audiencia en Las Estrellas",
    source: "TV Notas",
    time: "Hace 3 horas",
    category: "entretenimiento",
    image: "https://images.unsplash.com/photo-1536440136628-849c177e76a1?w=400",
    url: "https://www.tvnotas.com.mx"
  },
  {
    id: 3,
    title: "Las Posadas 2025: tradiciones mexicanas que no debes perderte",
    source: "El Universal",
    time: "Hace 5 horas",
    category: "noticias",
    image: "https://images.unsplash.com/photo-1504711434969-e33886168f5c?w=400",
    url: "https://www.eluniversal.com.mx/nacion/"
  },
  {
    id: 4,
    title: "Peso mexicano cierra estable ante incertidumbre global",
    source: "El Financiero",
    time: "Hace 1 día",
    category: "noticias",
    image: "https://images.unsplash.com/photo-1554224155-8d04cb21cd6c?w=400",
    url: "https://www.elfinanciero.com.mx/economia/"
  },
  {
    id: 5,
    title: "Tigres UANL termina segundo en el Apertura 2025",
    source: "Récord",
    time: "Hace 6 horas",
    category: "deportes",
    image: "https://images.unsplash.com/photo-1574629810360-7efbbe195018?w=400",
    url: "https://www.record.com.mx/futbol"
  },
  {
    id: 6,
    title: "Los Hilos del Pasado: la telenovela que cautiva a México",
    source: "Milenio",
    time: "Hace 8 horas",
    category: "entretenimiento",
    image: "https://images.unsplash.com/photo-1522869635100-9f4c5e86aa37?w=400",
    url: "https://www.milenio.com/espectaculos"
  },
  {
    id: 7,
    title: "Clima invernal llega a México: se esperan bajas temperaturas",
    source: "El Economista",
    time: "Hace 4 horas",
    category: "noticias",
    image: "https://images.unsplash.com/photo-1590283603385-17ffb3a7f29f?w=400",
    url: "https://www.eleconomista.com.mx/economia/"
  },
  {
    id: 8,
    title: "Cruz Azul busca revancha en el Clausura 2026",
    source: "Mediotiempo",
    time: "Hace 7 horas",
    category: "deportes",
    image: "https://images.unsplash.com/photo-1431324155629-1a6deb1dec8d?w=400",
    url: "https://www.mediotiempo.com/futbol/liga-mx"
  },
  {
    id: 9,
    title: "Navidad 2025: dónde ver las mejores luces en CDMX",
    source: "Cine Premiere",
    time: "Hace 9 horas",
    category: "entretenimiento",
    image: "https://images.unsplash.com/photo-1485846234645-a62644f84728?w=400",
    url: "https://www.cinepremiere.com.mx"
  },
  {
    id: 10,
    title: "Mercados navideños: guía para compras de temporada",
    source: "Forbes México",
    time: "Hace 5 horas",
    category: "noticias",
    image: "https://images.unsplash.com/photo-1495020689067-958852a7765e?w=400",
    url: "https://www.forbes.com.mx/economia-y-finanzas/"
  }
];

export const categories = [
  {
    name: "Noticias",
    icon: "newspaper",
    links: [
      { name: "El Universal", url: "https://www.eluniversal.com.mx" },
      { name: "Milenio", url: "https://www.milenio.com" },
      { name: "Reforma", url: "https://www.reforma.com" },
      { name: "La Jornada", url: "https://www.jornada.com.mx" },
      { name: "Excélsior", url: "https://www.excelsior.com.mx" }
    ]
  },
  {
    name: "Deportes",
    icon: "trophy",
    links: [
      { name: "ESPN MX", url: "https://www.espn.com.mx" },
      { name: "Récord", url: "https://www.record.com.mx" },
      { name: "TUDN", url: "https://www.tudn.mx" },
      { name: "Mediotiempo", url: "https://www.mediotiempo.com" }
    ]
  },
  {
    name: "Entretenimiento",
    icon: "star",
    links: [
      { name: "Televisa", url: "https://www.televisa.com" },
      { name: "TV Azteca", url: "https://www.tvazteca.com" },
      { name: "Cinépolis", url: "https://www.cinepolis.com" },
      { name: "Cinemex", url: "https://www.cinemex.com" }
    ]
  },
  {
    name: "Compras",
    icon: "shopping-bag",
    links: [
      { name: "Mercado Libre", url: "https://www.mercadolibre.com.mx" },
      { name: "Amazon MX", url: "https://www.amazon.com.mx" },
      { name: "Liverpool", url: "https://www.liverpool.com.mx" },
      { name: "Coppel", url: "https://www.coppel.com" }
    ]
  },
  {
    name: "Banca y Dinero",
    icon: "wallet",
    links: [
      { name: "BBVA", url: "https://www.bbva.mx" },
      { name: "Santander", url: "https://www.santander.com.mx" },
      { name: "Banorte", url: "https://www.banorte.com" },
      { name: "HSBC", url: "https://www.hsbc.com.mx" }
    ]
  },
  {
    name: "Gobierno",
    icon: "building-2",
    links: [
      { name: "Gob.mx", url: "https://www.gob.mx" },
      { name: "SAT", url: "https://www.sat.gob.mx" },
      { name: "IMSS", url: "https://www.imss.gob.mx" },
      { name: "INE", url: "https://www.ine.mx" }
    ]
  },
  {
    name: "Viajes",
    icon: "plane",
    links: [
      { name: "Aeroméxico", url: "https://www.aeromexico.com" },
      { name: "Volaris", url: "https://www.volaris.com" },
      { name: "VivaAerobus", url: "https://www.vivaaerobus.com" },
      { name: "Despegar", url: "https://www.despegar.com.mx" }
    ]
  },
  {
    name: "Educación",
    icon: "graduation-cap",
    links: [
      { name: "UNAM", url: "https://www.unam.mx" },
      { name: "IPN", url: "https://www.ipn.mx" },
      { name: "Tec de Monterrey", url: "https://www.tec.mx" },
      { name: "UAM", url: "https://www.uam.mx" }
    ]
  }
];

export const footerLinks = {
  "Redes Sociales": [
    { name: "Facebook", url: "https://www.facebook.com" },
    { name: "Instagram", url: "https://www.instagram.com" },
    { name: "X (Twitter)", url: "https://www.x.com" },
    { name: "TikTok", url: "https://www.tiktok.com" },
    { name: "LinkedIn", url: "https://www.linkedin.com" }
  ],
  "Compras Online": [
    { name: "Mercado Libre", url: "https://www.mercadolibre.com.mx" },
    { name: "Amazon MX", url: "https://www.amazon.com.mx" },
    { name: "Walmart", url: "https://www.walmart.com.mx" },
    { name: "Liverpool", url: "https://www.liverpool.com.mx" }
  ],
  "Servicios Públicos": [
    { name: "CFE", url: "https://www.cfe.mx" },
    { name: "IMSS", url: "https://www.imss.gob.mx" },
    { name: "SAT", url: "https://www.sat.gob.mx" },
    { name: "Gob.mx", url: "https://www.gob.mx" }
  ],
  "Entretenimiento": [
    { name: "Netflix", url: "https://www.netflix.com" },
    { name: "Disney+", url: "https://www.disneyplus.com" },
    { name: "Prime Video", url: "https://www.primevideo.com" },
    { name: "Spotify", url: "https://www.spotify.com" }
  ],
  "Mapas y Transporte": [
    { name: "Google Maps", url: "https://maps.google.com" },
    { name: "Uber", url: "https://www.uber.com" },
    { name: "DiDi", url: "https://www.didiglobal.com" },
    { name: "Metro CDMX", url: "https://www.metro.cdmx.gob.mx" }
  ]
};